import {
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Flex,
  Form,
  Input,
  InputNumber,
  Layout,
  Radio,
  Row,
  Select,
  Switch,
  Typography,
} from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import dayjs from 'dayjs';
import { Lunar } from 'lunar-typescript';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import iconSetting from '../../assets/images/schedules/icon-setting-schedule.svg';
import '../../assets/styles/scheduleSetting.scss';
import NumberInputName from '../../components/NumberInputName';
import StepSchedules from '../../components/StepSchedules';
import { Constant, DateFormat, DRIVER, EXTRA_DRIVER, TYPE_HOUR, TYPE_MINUTE, YearFormat } from '../../config/constant';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { fetchListBus, listBusSelector } from '../../redux/slice/buses/bus';
import { getAllAvailableBusType } from '../../redux/slice/busTypes/listBusTypeSlice';
import { driverSelector, fetchListDriver, fetchListExtraDriver } from '../../redux/slice/driverSlice';
import {
  ListScheduleSelector,
  setDataSchedule,
  setListFare,
  setUpdateSchedule,
} from '../../redux/slice/schdules/scheduleSlice';
import { daysInWeek } from '../../utils/daysInWeekItem';
import LocationModal from './ModalSchedules/LocationModal';

export enum ScheduleType {
  specific_date = 'specific_date',
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
  days = 'days',
}

function SettingSchedule() {
  const { t } = useTranslation();
  const {
    listSegment,
    listTransships,
    dataSchedule,
    isDetailSchedule,
    listScheduleDetail,
    isUpdateSchedule,
    idSeatMap,
  } = useAppSelector(ListScheduleSelector);
  const { drivers, extra_drivers } = useAppSelector(driverSelector);
  const { buses, loading: loadingBus } = useAppSelector(listBusSelector);
  const [form] = Form.useForm();
  const [keywordBus, setKeywordBus] = useState<any>({});
  const [openModalLocation, setOpenModalLocation] = useState<boolean>(false);
  const [isLastItem, setIsLastItem] = useState<boolean>(false);
  const [segmentActive, setSegmentActive] = useState<any>(1);
  const [selectBus, setSelectBus] = useState<undefined | string>(undefined);
  const [keywordDriver, setKeywordDriver] = useState<any>();
  const [KeywordBusList, setKeywordBusList] = useState<any>();
  const [selectDriver, setSelectDriver] = useState<undefined | string>(undefined);
  const [selectExtraDriver, setSelectExtraDriver] = useState<undefined | string>(undefined);
  const [keywordExtraDriver, setKeywordExtraDriver] = useState<any>();
  const frequencyType = Form.useWatch('frequency_type', form);
  const autoOperation = Form.useWatch('auto_operated', form);
  const watchIsContract = Form.useWatch('is_contract', form);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const scrollToErrorField = (errorFields: any) => {
    const [firstErrorField] = errorFields;
    if (firstErrorField) {
      form.scrollToField(firstErrorField.name);
    }
  };
  const onToggleIsBooking = (checked: boolean) => {
    form.setFieldsValue({ is_diagram: checked });
  };
  const onToggleIsBookingCompany = (checked: boolean) => {
    form.setFieldsValue({ is_online_company: checked });
  };
  const onToggleIsBookingOpenApi = (checked: boolean) => {
    form.setFieldsValue({ is_diagram_openapi: checked });
  };
  const onToggleIsBookingDiagramCompany = (checked: boolean) => {
    form.setFieldsValue({ is_diagram_company: checked });
  };
  function onSearchBus(value: any) {
    setKeywordBusList(value);
  }
  const handleChangeBus = (value: string, option: any) => {
    setSelectBus(value);
    form.setFieldsValue({
      bus_id: option?.value,
    });
  };
  const filterOptionBus = (
    input: string,
    option?: {
      label?: any;
      value?: any;
      seatMap?: any;
    },
  ) => (option?.label ?? '').toLowerCase()?.includes(input.toLowerCase());

  const onSearchDriver = (value: string) => {
    setKeywordDriver(value);
  };
  const filterOptionDriver = (
    input: string,
    option?: {
      label: string;
      value: string;
      date_of_birth: string;
      phone: string;
      date_expired_license: string;
      license_class: string;
    },
  ) => (option?.label ?? '')?.toLowerCase()?.includes(input?.toLowerCase());
  const handleChangeDriver = (value: string, option: any) => {
    setSelectDriver(value);
    form.setFieldsValue({
      driver_id: value,
    });
  };

  const daysInWeekCheckbox = daysInWeek.map((item) => {
    return (
      <Col span={6}>
        <Checkbox value={item?.value}>{item?.label}</Checkbox>
      </Col>
    );
  });
  const daysInMonthCheckbox = Array.from({ length: 31 }, (_, index) => {
    const checkboxValue = index + 1;
    return (
      <Col span={3} key={checkboxValue}>
        <Checkbox value={checkboxValue < 10 ? `0${checkboxValue}` : `${checkboxValue}`}>{checkboxValue}</Checkbox>
      </Col>
    );
  });

  const handleChangeExtraDriver = (value: string, option: any) => {
    setSelectExtraDriver(value);
    form.setFieldsValue({
      extra_driver_id: value,
    });
  };
  const onSearchExtraDriver = (value: string) => {
    setKeywordExtraDriver(value);
  };
  const handleChangeScheduleType = (value: string) => {
    form.setFieldsValue({ frequency_value: null });
  };
  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    return current && current < dayjs(new Date());
  };
  const onFinish = (value: any) => {
    value.is_contract = value?.is_contract ? true : false;
    value.contract_value = value.contract_value
      ? Number(`${value.contract_value}`.replace(/\$\s?|(,*)/g, ''))
      : undefined;
    value.close_before_type = form.getFieldValue('close_before_type');
    if (form.getFieldValue('close_before_type') === TYPE_MINUTE) {
      value.close_before = form.getFieldValue('close_before_time') || 0;
      value.close_before_hour = undefined;
    } else {
      value.close_before_hour = form.getFieldValue('close_before_time') || 0;
      value.close_before = undefined;
    }
    value.reservation_type = form.getFieldValue('reservation_type');
    if (form.getFieldValue('reservation_type') === TYPE_MINUTE) {
      value.reservation_minute = form.getFieldValue('reservation_time') || 0;
      value.reservation_hour = undefined;
    } else {
      value.reservation_hour = form.getFieldValue('reservation_time') || 0;
      value.reservation_minute = undefined;
    }
    if (form.getFieldValue('frequency_type') === ScheduleType.specific_date) {
      value.frequency_value = dayjs(value?.frequency_value).format(YearFormat);
    }
    value.open_before = form.getFieldValue('open_before');
    value.frequency_type = form.getFieldValue('frequency_type');
    value.is_diagram = value.is_diagram ? value.is_diagram : false;
    value.is_online_company = value.is_online_company ? value.is_online_company : false;
    value.is_diagram_company = value.is_diagram_company ? value.is_diagram_company : false;
    // value.bus_id = value.bus_id ? value.bus_id : undefined;
    value.contract_value = value.is_contract ? value.contract_value : undefined;
    dispatch(setDataSchedule(value));
    if (isDetailSchedule) {
      dispatch(setUpdateSchedule(true));
    }
    if (!value.is_diagram && listScheduleDetail?.is_diagram) {
      dispatch(setListFare([]));
    }
    navigate('/bus-management/schedules/agent-seats');
  };

  useEffect(() => {
    dispatch(getAllAvailableBusType({ keyword: keywordBus }));
  }, [dispatch, keywordBus]);

  useEffect(() => {
    dispatch(
      fetchListDriver({
        keyword: keywordDriver,
        status: Constant.STATUS_ACTIVE,
        type: DRIVER,
      }),
    );
  }, [dispatch, keywordDriver]);

  useEffect(() => {
    dispatch(
      fetchListExtraDriver({
        keyword: keywordExtraDriver,
        status: Constant.STATUS_ACTIVE,
        type: EXTRA_DRIVER,
      }),
    );
  }, [dispatch, keywordExtraDriver]);
  useEffect(() => {
    if (listSegment?.bus_type_id)
      dispatch(
        fetchListBus({
          keyword: KeywordBusList,
          bus_type_id: listSegment?.bus_type_id,
          status: true,
        }),
      );
  }, [dispatch, KeywordBusList, listSegment]);

  useEffect(() => {
    if (dataSchedule?.open_before) {
      form.setFieldsValue({
        frequency_type: dataSchedule?.frequency_type,
        auto_operated: dataSchedule?.auto_operated,
        is_online: dataSchedule?.is_online,
        reservation_type: dataSchedule?.reservation_minute ? TYPE_MINUTE : TYPE_HOUR,
        reservation_time:
          (dataSchedule.reservation_minute ? dataSchedule.reservation_minute : dataSchedule.reservation_hour) || 0,
        close_before_type: dataSchedule?.close_before ? TYPE_MINUTE : TYPE_HOUR,
        close_before_time:
          (dataSchedule?.close_before ? dataSchedule.close_before : dataSchedule.close_before_hour) || 0,
        open_before: dataSchedule?.open_before,
        open_before_time: dataSchedule?.open_before,
        pay_later: dataSchedule?.pay_later,
        plate_number: dataSchedule?.bus?.plate_number ? dataSchedule?.bus?.plate_number : dataSchedule?.plate_number,
        driver_id: dataSchedule?.driver_id ? dataSchedule?.driver_id : undefined,
        is_contract: dataSchedule?.is_contract,
        contract_value: dataSchedule?.contract_value,
        extra_driver_id: dataSchedule?.extra_driver_id ? dataSchedule?.extra_driver_id : undefined,
        bus_id: dataSchedule?.bus_id ? dataSchedule?.bus_id : listScheduleDetail?.bus?.id,
        is_diagram_openapi: dataSchedule?.is_diagram_openapi,
        is_diagram: dataSchedule?.is_diagram,
        is_online_company: dataSchedule?.is_online_company,
        is_diagram_company: dataSchedule?.is_diagram_company,
      });
      if (listScheduleDetail?.bus_type?.id !== idSeatMap) {
        form.setFieldsValue({
          auto_operated: false,
          bus_id: undefined,
          driver_id: undefined,
          extra_driver_id: undefined,
        });
      }
      if (dataSchedule?.frequency_type && dataSchedule?.frequency_type === ScheduleType.specific_date) {
        const day = dataSchedule?.frequency_value.split('/').reverse().join('/');
        form.setFieldValue('frequency_value', dayjs(day));
      } else {
        form.setFieldValue('frequency_value', dataSchedule?.frequency_value);
      }
    }
  }, [dataSchedule, listScheduleDetail, idSeatMap]);

  useEffect(() => {
    if (isDetailSchedule && !isUpdateSchedule) {
      form.setFieldsValue({
        frequency_type: listScheduleDetail?.frequency_type,
        auto_operated: listScheduleDetail?.auto_operated,
        is_online: listScheduleDetail?.is_online,
        reservation_type: listScheduleDetail?.reservation_minute ? TYPE_MINUTE : TYPE_HOUR,
        reservation_time:
          (listScheduleDetail.reservation_minute
            ? listScheduleDetail.reservation_minute
            : listScheduleDetail.reservation_hour) || 0,
        close_before_type: listScheduleDetail?.close_before ? TYPE_MINUTE : TYPE_HOUR,
        close_before_time:
          (listScheduleDetail?.close_before ? listScheduleDetail.close_before : listScheduleDetail.close_before_hour) ||
          0,
        open_before: listScheduleDetail?.open_before,
        open_before_time: listScheduleDetail?.open_before,
        pay_later: listScheduleDetail?.pay_later,
        plate_number: listScheduleDetail?.bus?.plate_number
          ? listScheduleDetail?.bus?.plate_number
          : listScheduleDetail?.plate_number,
        driver_id: listScheduleDetail?.drivers?.length ? listScheduleDetail?.drivers[0]?.id : undefined,
        is_contract: listScheduleDetail?.is_contract,
        contract_value: listScheduleDetail?.contract_value,
        extra_driver_id: listScheduleDetail?.extra_drivers?.length
          ? listScheduleDetail?.extra_drivers[0]?.id
          : undefined,
        bus_id: listScheduleDetail?.bus?.id,
        is_diagram_openapi: listScheduleDetail?.is_diagram_openapi,
        is_diagram: listScheduleDetail?.is_diagram,
        is_online_company: listScheduleDetail?.is_online_company,
        is_diagram_company: listScheduleDetail?.is_diagram_company,
      });
      if (listScheduleDetail?.frequency_type && listScheduleDetail?.frequency_type === ScheduleType.specific_date) {
        const day = listScheduleDetail?.frequency_value.split('/').reverse().join('/');
        form.setFieldValue('frequency_value', dayjs(day));
      } else {
        form.setFieldValue('frequency_value', listScheduleDetail?.frequency_value);
      }
      if (listScheduleDetail?.bus_type?.id !== idSeatMap) {
        form.setFieldsValue({
          auto_operated: false,
          bus_id: undefined,
          driver_id: undefined,
          extra_driver_id: undefined,
        });
      }
    }
  }, [isDetailSchedule, isUpdateSchedule, listScheduleDetail, idSeatMap]);
  return (
    <Layout className="min-vh-70 segment-booking schedule schedule-modal">
      <Card>
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          autoComplete="off"
          validateTrigger="onSubmit"
          name="segment-setting-form"
          colon={false}
          labelCol={{ span: 12 }}
          labelAlign={'left'}
          labelWrap
          initialValues={{
            reservation_type: TYPE_MINUTE,
            close_before_type: TYPE_MINUTE,
            close_before: 0,
            open_before: 0,
            reservation_minute: 0,
            is_contract: false,
            is_diagram: true,
            is_diagram_openapi: true,
            is_online_company: true,
            is_diagram_company: true,
            is_online: true,
            pay_later: true,
            auto_operated: false,
          }}
          onFieldsChange={(allFields) => {
            scrollToErrorField(allFields.filter((field) => field.errors && field.errors.length > 0));
          }}
        >
          <StepSchedules step={3} />
          <div className="segment-block setting-schedule">
            <div className="mt-4 border-b-segment pb-3">
              <Flex gap={16}>
                <img src={iconSetting} alt="" />
                <div>
                  <Typography.Text className="fw-600 fs-18 title-segment">Cài đặt lịch chạy</Typography.Text> <br />
                  <Typography.Text className="fw-500 fs-16" style={{ color: '#4F5662' }}>{`Tuyến: ${
                    listSegment?.depart_point ?? ''
                  } - ${listSegment?.arrive_point ?? ''}, Giờ đi: ${listSegment?.depart_time}`}</Typography.Text>
                </div>
              </Flex>
            </div>
            <div className="block-setting-schedule-content mt-3">
              <Row gutter={16}>
                <Col xs={24} md={5}>
                  <span className="required">{t('Mở chuyến trước')}</span>
                  <Form.Item
                    name="open_before_time"
                    className="form-item-name required mt-2 open-before-time"
                    validateTrigger={['onChange', 'onBlur']}
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!getFieldValue('open_before')) {
                            return Promise.reject(new Error('Vui lòng nhập thời gian mở chuyến trước'));
                          } else {
                            return Promise.resolve();
                          }
                        },
                      }),
                    ]}
                  >
                    <Flex className="input-flex-container" gap={0} align="center" vertical={false}>
                      <NumberInputName name={'open_before'} form={form} />
                      <Divider type="vertical" />
                      <Flex className="input-suffix-container" align="center">
                        <span className="fw-600 text-color-green-default">{t('Ngày')}</span>
                      </Flex>
                    </Flex>
                  </Form.Item>
                </Col>
                <Col xs={24} md={5} className={'box-input-time'}>
                  <span>Đóng chuyến trước</span>
                  <Form.Item
                    name={'close_before_time_input'}
                    className="form-item-name mt-2 pickup-time"
                    validateTrigger={['onChange', 'onBlur']}
                  >
                    <Flex className="input-flex-container" gap={0} align="center" vertical={false}>
                      <NumberInputName name={'close_before_time'} form={form} placeholder="Số phút / giờ" />
                      <Divider type="vertical" />
                      <Form.Item name={'close_before_type'} validateTrigger={['onChange', 'onBlur']}>
                        <Radio.Group size="small">
                          <Radio.Button value={TYPE_MINUTE}>Phút</Radio.Button>
                          <Radio.Button value={TYPE_HOUR}>{t('Giờ')}</Radio.Button>
                        </Radio.Group>
                      </Form.Item>
                    </Flex>
                  </Form.Item>
                </Col>
                <Col xs={24} md={5}>
                  <span>Thời gian giữ chỗ</span>
                  <Form.Item
                    name={'reservation_time_close'}
                    className="form-item-name required mt-2 pickup-time"
                    validateTrigger={['onChange', 'onBlur']}
                  >
                    <Flex className="input-flex-container" gap={0} align="center" vertical={false}>
                      <NumberInputName name={'reservation_time'} form={form} placeholder="Số phút / giờ" />
                      <Divider type="vertical" />
                      <Form.Item name={'reservation_type'} validateTrigger={['onChange', 'onBlur']}>
                        <Radio.Group size="small">
                          <Radio.Button value={TYPE_MINUTE}>{t('Phút')}</Radio.Button>
                          <Radio.Button value={TYPE_HOUR}>{t('Giờ')}</Radio.Button>
                        </Radio.Group>
                      </Form.Item>
                    </Flex>
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ width: '100%' }}>
                <Col xs={24} md={10} className="schedule-input">
                  <Row gutter={12}>
                    <Col xs={24} md={13}>
                      <span className="required">{t('Thiết lập lịch chạy')}</span>
                      <Form.Item
                        name="frequency_type"
                        className="form-item-name required mt-2"
                        validateTrigger={['onChange', 'onBlur']}
                      >
                        <Select
                          className="input-h36"
                          placeholder="Chọn thiết lập"
                          size="large"
                          optionFilterProp="children"
                          style={{ width: '100%' }}
                          onChange={handleChangeScheduleType}
                          options={[
                            { value: 'specific_date', label: t('Chọn ngày') },
                            { value: 'daily', label: t('Hàng ngày') },
                            { value: 'weekly', label: t('Hàng tuần') },
                            { value: 'monthly', label: t('Hàng tháng') },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                    {frequencyType === ScheduleType.specific_date && (
                      <Col xs={24} md={10}>
                        <Form.Item
                          name="frequency_value"
                          label=""
                          style={{ marginTop: '33px' }}
                          validateTrigger={['onChange', 'onBlur']}
                        >
                          {frequencyType === ScheduleType.specific_date && (
                            <DatePicker
                              className="w-60 input-height"
                              placeholder={t('Chọn ngày')}
                              disabledDate={disabledDate}
                              allowClear={false}
                              cellRender={(current: any) => {
                                // @ts-ignore
                                let d = Lunar.fromDate(new Date(current));
                                const lunar = d.getDay();
                                const lunarMonth = d.getMonth();
                                return (
                                  <div>
                                    <div className="fs-14 fw-500">{current.date()}</div>
                                    <div className="fs-12 lunar fw-500">
                                      {lunar}
                                      {
                                        // eslint-disable-next-line eqeqeq
                                        lunar == 1 || current.date() == 1 ? `/${lunarMonth}` : null
                                      }
                                    </div>
                                  </div>
                                );
                              }}
                              format={DateFormat}
                            />
                          )}
                        </Form.Item>
                      </Col>
                    )}
                  </Row>
                  <Row gutter={16} className="w-100">
                    {frequencyType !== ScheduleType.specific_date && (
                      <Col xs={24} md={24}>
                        <Form.Item
                          name="frequency_value"
                          rules={[
                            {
                              required: !!(
                                form.getFieldValue('frequency_type') &&
                                form.getFieldValue('frequency_type') !== ScheduleType.daily
                              ),
                              message: t('Vui lòng thiết lập lịch chạy'),
                            },
                          ]}
                          validateTrigger={['onChange', 'onBlur']}
                        >
                          {frequencyType === ScheduleType.weekly && (
                            <Checkbox.Group className="days-select-checkbox">
                              <Row>{daysInWeekCheckbox}</Row>
                            </Checkbox.Group>
                          )}
                          {frequencyType === ScheduleType.monthly && (
                            <Checkbox.Group className="days-select-checkbox">
                              <Row>{daysInMonthCheckbox}</Row>
                            </Checkbox.Group>
                          )}
                        </Form.Item>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </div>
            <div className="block-setting-schedule-switch mt-4">
              <Row className="d-flex" style={{ alignItems: 'center', columnGap: '8px' }}>
                <Form.Item
                  name="auto_operated"
                  className="form-item-name required"
                  valuePropName="checked"
                  validateTrigger={['onChange', 'onBlur']}
                >
                  <Switch className="mt-3" defaultChecked disabled={!buses?.length} loading={loadingBus} />
                </Form.Item>
                <Typography>{t('Tự động điều hành')}</Typography>
              </Row>

              {autoOperation && (
                <Row gutter={15} className="w-100">
                  <Col xs={10} sm={10} md={5}>
                    <span className="required">{t(`Biển số xe`)}</span>
                    <Form.Item
                      name="plate_number"
                      className="fw-500"
                      rules={[
                        {
                          required: true,
                          message: t('Vui lòng chọn xe'),
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        onChange={handleChangeBus}
                        value={selectBus}
                        placeholder={t('Nhập biển số xe')}
                        onSearch={onSearchBus}
                        filterOption={filterOptionBus}
                        className="mt-1"
                        options={
                          buses?.length > 0
                            ? buses?.map((item: any) => ({
                                value: item?.id,
                                label: item?.plate_number,
                                bus_type: item?.bus_type?.name,
                                bus_name: item?.name,
                              }))
                            : []
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={12} md={6}>
                    <span className="required">{t(`Chọn tài xế`)}</span>
                    <Form.Item name="driver_id" rules={[{ required: true, message: 'Vui lòng chọn tài xế' }]}>
                      <Select
                        showSearch
                        onChange={(value: any, option: any) => handleChangeDriver(value, option)}
                        value={selectBus}
                        placeholder={t('Chọn tài xế')}
                        onSearch={onSearchDriver}
                        className="mt-1 "
                        filterOption={filterOptionDriver}
                        options={
                          drivers?.length > 0
                            ? drivers?.map((item: any) => ({
                                value: item?.id,
                                label: item?.name,
                                date_of_birth: item?.date_of_birth,
                                phone: item?.phone,
                                date_expired_license: item?.date_expired_license,
                                license_class: item?.license_class,
                              }))
                            : []
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={12} md={6}>
                    <span>{t(`Chọn phụ xe`)}</span>
                    <Form.Item name="extra_driver_id">
                      <Select
                        showSearch
                        onChange={(value: any, option: any) => handleChangeExtraDriver(value, option)}
                        value={selectBus}
                        className="mt-1"
                        placeholder={t('Chọn phụ xe')}
                        onSearch={onSearchExtraDriver}
                        filterOption={filterOptionDriver}
                        options={
                          extra_drivers?.length > 0
                            ? extra_drivers?.map((item: any) => ({
                                value: item?.id,
                                label: item?.name,
                                date_of_birth: item?.date_of_birth,
                                phone: item?.phone,
                                date_expired_license: item?.date_expired_license,
                                license_class: item?.license_class,
                              }))
                            : []
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Form.Item name="bus_id" className={'d-none'}>
                <Input disabled />
              </Form.Item>
              <Flex align="center" gap="small">
                <Form.Item
                  name="is_contract"
                  className="form-item-name required"
                  validateTrigger={['onChange', 'onBlur']}
                >
                  <Switch className="mt-3" />
                </Form.Item>
                <Typography>Cho thuê xe hợp đồng</Typography>
              </Flex>
              <Col xs={24} md={6} className={`${watchIsContract ? `` : 'd-none'}`}>
                <div>
                  <span className={`required mb-2`}>Giá hợp đồng</span>
                  <Form.Item
                    className="form-item-name form-item-name--price_common require price mt-2"
                    name="contract_value"
                    dependencies={['is_contract']}
                    validateTrigger={['onChange', 'onBlur']}
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (getFieldValue('is_contract')) {
                            if (value) {
                              return Promise.resolve();
                            } else {
                              return Promise.reject(new Error('Vui lòng nhập giá hợp đồng'));
                            }
                          } else {
                            return Promise.resolve();
                          }
                        },
                      }),
                    ]}
                  >
                    <InputNumber<number>
                      className="w-100"
                      addonAfter="đ"
                      formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      controls={false}
                      placeholder="Nhập giá hợp đồng"
                      parser={(value) => value?.replace(/\$\s?|(,*)/g, '') as unknown as number}
                    />
                  </Form.Item>
                </div>
              </Col>

              <Row className="d-flex" style={{ alignItems: 'center', columnGap: '8px' }}>
                <Form.Item
                  name="is_online_company"
                  className="form-item-name required"
                  valuePropName="checked"
                  validateTrigger={['onChange', 'onBlur']}
                >
                  <Switch onClick={onToggleIsBookingCompany} className=" mt-3" defaultChecked />
                </Form.Item>
                <Typography>{t('Cho phép bán online trên API nhà xe')}</Typography>
              </Row>
              <Row className="d-flex" style={{ alignItems: 'center', columnGap: '8px' }}>
                <Form.Item
                  name="is_online"
                  className="form-item-name required"
                  valuePropName="checked"
                  validateTrigger={['onChange', 'onBlur']}
                >
                  <Switch className="mt-3" defaultChecked />
                </Form.Item>
                <Typography>Cho phép bán online trên Carlink API</Typography>
              </Row>
              <Row className="d-flex" style={{ alignItems: 'center', columnGap: '8px' }}>
                <Form.Item
                  name="is_diagram"
                  className="form-item-name required"
                  valuePropName="checked"
                  validateTrigger={['onChange', 'onBlur']}
                >
                  <Switch onClick={onToggleIsBooking} className=" mt-3" defaultChecked />
                </Form.Item>
                <Typography>{t('Cho phép chọn chỗ trên Phần mềm bán vé')}</Typography>
              </Row>
              <Row className="d-flex" style={{ alignItems: 'center', columnGap: '8px' }}>
                <Form.Item
                  name="is_diagram_openapi"
                  className="form-item-name required"
                  valuePropName="checked"
                  validateTrigger={['onChange', 'onBlur']}
                >
                  <Switch onClick={onToggleIsBookingOpenApi} className=" mt-3" defaultChecked />
                </Form.Item>
                <Typography>{t('Cho phép chọn chỗ trên Carlink API')}</Typography>
              </Row>
              <Row className="d-flex" style={{ alignItems: 'center', columnGap: '8px' }}>
                <Form.Item
                  name="is_diagram_company"
                  className="form-item-name required"
                  valuePropName="checked"
                  validateTrigger={['onChange', 'onBlur']}
                >
                  <Switch onClick={onToggleIsBookingDiagramCompany} className=" mt-3" defaultChecked />
                </Form.Item>
                <Typography>{t('Cho phép chọn chỗ trên API nhà xe')}</Typography>
              </Row>

              <Row className="d-flex" style={{ alignItems: 'center', columnGap: '8px' }}>
                <Form.Item
                  name="pay_later"
                  className="form-item-name required"
                  valuePropName="checked"
                  validateTrigger={['onChange', 'onBlur']}
                >
                  <Switch className="mt-3" defaultChecked />
                </Form.Item>
                <Typography>Cho phép thanh toán tại nhà xe</Typography>
              </Row>
            </div>
          </div>
          <LocationModal
            modalOpen={openModalLocation}
            onCancel={() => {
              setOpenModalLocation(false);
              setIsLastItem(false);
            }}
            formLocation={form}
            onOk={() => {}}
            isLastItem={isLastItem}
            segmentActive={segmentActive}
            listTransships={listTransships}
          />
        </Form>
      </Card>
    </Layout>
  );
}

export default SettingSchedule;
